import { Usuario } from './usuario.entity';
import { AltaUsuario } from './altausuario.entity';
import { ValidateNested } from 'class-validator';

export class RegisterUser {
    @ValidateNested()
    Usuario: Usuario;
    @ValidateNested()
    AltaUsuario: AltaUsuario;
    gRecaptchaResponse: string;
}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/entities/RegisterUser.entity.ts